<template>
  <div class="index-box">
    <div class="text-jieshao" v-if="historyList != ''">
      <div class="contentTxt">
        <div v-for="(segment, index) in historyList" :key="index">
          {{ segment }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      profiles: "",
      historyList: [],
    };
  },
  created() {
    this.getHistoricalIntroductionn();
  },
  methods: {
    async getHistoricalIntroductionn() {
      const result = await this.$http.get("/schoolProfiles/getHistory");
      console.log("获取学校历史", result.data);
      this.profiles = result.data[0].title;
      const content = result.data[0].comment.split("\n");
      // 重新组合分段，包含关键字
      const historyList = [];
      for (let i = 0; i < content.length; i++) {
        historyList.push(content[i]);
      }
      this.historyList = historyList;
    },
  },
};
</script>
<style lang="less" scoped>
.index-box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .text-jieshao {
    display: flex;
    flex-direction: column;
    width: 95vw;
    border-radius: 10px;
    border: 1px solid #e2e2e2;
    background: #fff;
    font-size: 1rem;
    font-weight: 500;
    line-height: 25px; //行间距
    color: #747474;
    text-indent: 4ch; //首行缩进
    text-align: justify; //两端对齐
    margin-top: 10px;
    .contentTxt {
      padding: 0.5rem 1rem 1rem 1rem;
      line-height: 25px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/alumniHome/HistoricalIntroduction.vue